export function countdown({ endTime }) {
  return {
    ready: false,
    endTimeMs: endTime * 1000,
    timer: null,
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',

    init() {
      this.update();
      this.timer = setInterval(() => this.update(), 1000);
      this.$store.serverTime.sync();
    },

    destroy() {
      clearInterval(this.timer);
    },

    update() {
      const remaining = this.endTimeMs - this.$store.serverTime.nowMs();

      if (remaining <= 0) {
        this.days = this.hours = this.minutes = this.seconds = '00';
        clearInterval(this.timer);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);

      this.days    = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      this.hours   = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      this.minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      this.seconds = String(totalSeconds % 60).padStart(2, '0');

      this.ready = true;
    },
  };
}

function formatCountdownLabel(remainingMs, labels) {
  const totalHours = Math.floor(remainingMs / 3600000);
  let count, template;

  if (totalHours >= 24) {
    count = Math.floor(remainingMs / 86400000);
    template = count === 1 ? labels.days : labels.daysPlural;
  } else if (totalHours >= 1) {
    count = totalHours;
    template = count === 1 ? labels.hours : labels.hoursPlural;
  } else {
    count = Math.floor(remainingMs / 60000);
    template = count === 1 ? labels.minutes : labels.minutesPlural;
  }

  return template.replace('{count}', count);
}

export function countdownLabel({ endTime, labels }) {
  const isDynamic = typeof endTime === 'function';
  const getEndTime = isDynamic ? endTime : () => endTime;

  return {
    visible: false,
    label: '',
    timer: null,

    init() {
      this.update();
      this.timer = setInterval(() => this.update(), 1000);
      this.$store.serverTime.sync();
    },

    destroy() {
      clearInterval(this.timer);
    },

    update() {
      const endTimeValue = getEndTime();
      const remaining = endTimeValue
        ? (endTimeValue * 1000) - this.$store.serverTime.nowMs()
        : -1;

      if (remaining <= 0) {
        this.visible = false;
        if (!isDynamic) clearInterval(this.timer);
        return;
      }

      this.label = formatCountdownLabel(remaining, labels);
      this.visible = true;
    },
  };
}
